import Link from "next/link";
import React, { Children } from "react";
import { useRouter } from "next/router";

const NavLink = ({ children, exact = false, active = true, ...props }) => {
  const { asPath } = useRouter();
  const child = Children.only(children);
  const childClassName = child.props.className || "";
  const classByStatus = active ? "zText-red-primary font-bold underline" : "";
  const isActive = exact
    ? (props.as || props.href) === asPath
    : asPath.startsWith(props.as || props.href);

  const mergedClass = isActive
    ? `${childClassName} ${classByStatus}`
    : childClassName;

  return (
    <Link href={props.href} {...props}>
      {React.cloneElement(child, {
        className: mergedClass || null,
      })}
    </Link>
  );
};

export default NavLink;
